<template>
  <v-data-table
    :headers="headers"
    :items="phaselist"
    sort-by="id"
    class="elevation-1 dark-last-row"
    hide-default-footer
    item-key="id"
    :loading="loading"
    items-per-page="500"
    show-expand
    :single-expand="singleExpand"
    :expanded.sync="expanded"
  >
    <template v-slot:top>
      <v-toolbar
        flat
        color="#004889"
      >
        <!--<v-toolbar-title class="white--text">Issues</v-toolbar-title>-->
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialog"
          max-width="500px"
          scrollable
        >
          <!--<template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              tile
              small
            >
              <v-icon dark>mdi-plus</v-icon>
              Add
            </v-btn>
          </template>-->
          <v-card flat color="#004889">
            <v-card-title class="accent">
              <span class="title text-uppercase white--text">{{ formTitle }}</span>
            </v-card-title>

           <v-card-text class="pa-0">
              <ValidationObserver ref="observer1">
                <v-form ref="warrantyform">
                  <v-list flat color="#004889" class="py-0">
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Assignee</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Assignee" rules="required">
                                <v-select
                                  v-model="editedItem.team"
                                  :items="teams"
                                  item-text="title"
                                  item-value="id"
                                  label="Select a Team"
                                  solo
                                  flat
                                  dark
                                  :error-messages="errors"
                                  required
                                >
                                </v-select>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Start Date</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-menu
                                v-model="menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="computedStartDateFormatted"
                                    label="Start Date"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    solo
                                    flat
                                    dark
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                v-model="editedItem.start_date"
                                @input="menu = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">End Date</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-menu
                              v-model="menu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                          >
                              <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  v-model="computedEndDateFormatted"
                                  label="End Date"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  solo
                                  flat
                                  dark
                              ></v-text-field>
                              </template>
                              <v-date-picker
                              v-model="editedItem.end_date"
                              @input="menu = false"
                              ></v-date-picker>
                          </v-menu>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Status</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Status" rules="required">
                              <v-select
                                  v-model="editedItem.status"
                                  :items="statuses"
                                  item-text="label"
                                  item-value="value"
                                  label="Status"
                                  :error-messages="errors"
                                  required
                                  solo
                                  flat
                                  dark
                              ></v-select>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Description</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-textarea
                              v-model="editedItem.description"
                              label="Description"
                              required
                              solo
                              flat
                              dark
                            ></v-textarea>
                        </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-form>
              </ValidationObserver>
            </v-card-text>
            <v-card-actions class="accent">
              <v-btn
                large min-width="49%" color="white" text
                @click="close"
              >
                Cancel
              </v-btn>
              <v-btn
                large min-width="49%" color="primary" tile
                @click="save"
                :loading="loading"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card color="red">
            <v-card-title class="subtitle-2 justify-center white--text">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions class="red darken-4">
              <v-spacer></v-spacer>
              <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn large min-width="50%" color="primary" tile @click="editItem(item)">      
        <v-icon
        >
          mdi-pencil
        </v-icon>
      </v-btn>             
      <!--<v-btn large min-width="50%" color="red" tile @click="deleteItem(item.id)">
        <v-icon
        color="white"
        >
        mdi-delete
      </v-icon>  
      </v-btn>--> 
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        :to="`/job/details/${job}`"
        tile
        :loading="loading"
      >
        Job Type is Empty. Click here to Set a Job Type.
      </v-btn>
    </template>
    <template v-slot:item.status="props">
      <v-edit-dialog
        :return-value.sync="props.item.status"
        @save="saveField(props.item.id)"
        large
      >
        <v-chip
          color="green"
          text-color="white"
          v-if="props.item.status == 'completed'"
        >
          Completed
        </v-chip>
        <v-chip
          color="primary"
          text-color="white"
          v-else-if="props.item.status == 'pending'"
        >
          Pending
        </v-chip>
        <v-chip
          color="orange"
          text-color="white"
          v-else-if="props.item.status == 'in_progress'"
        >
          In Progress
        </v-chip>
        <v-chip
          color="red"
          text-color="white"
          v-else-if="props.item.status == 'cancelled'"
        >
          Cancelled
        </v-chip>
        <template v-slot:input>
          <v-select
              v-model="props.item.status"
              :items="statuses"
              item-text="label"
              item-value="value"
              label="Status"
          ></v-select>
        </template>
      </v-edit-dialog>
    </template>
    <template v-slot:item.team="{ item }">
      <span v-if="item.team">{{ getTeam(item.team) }}</span>
      <span v-else>
        <v-btn
          tile
          text
          small
          @click="editItem(item)"
        >
        <v-icon left>
          mdi-plus
        </v-icon>
          Assign
        </v-btn>
      </span>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        Description: {{ item.description }}
      </td>
    </template>
    <template v-slot:item.start_date="{ item }">
      <span>{{ formatDate(item.start_date) }}</span>
    </template>
    <template v-slot:item.end_date="{ item }">
      <span>{{ formatDate(item.end_date) }}</span>
    </template>
  </v-data-table>
</template>

<script>
    import axios from 'axios'
    import { required } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
    import mixin from '../../mixin/main.js'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        mixins: [mixin],
        props: ['job'],
        data: () => ({
            loading: false,
            dialog: false,
            dialogDelete: false,
            expanded: [],
            singleExpand: false,
            headers: [
                {
                  text: 'Phase',
                  align: 'start',
                  sortable: false,
                  value: 'title',
                },
                { text: 'Status', value: 'status', sortable: false },
                { text: 'Assignee', value: 'team', sortable: false },
                { text: 'Start Date', value: 'start_date', sortable: false },
                { text: 'End Date', value: 'end_date', sortable: false },
                { text: 'Actions', value: 'actions', sortable: false, align: 'right' },
                { text: '', value: 'data-table-expand' },
            ],
            phaselist: [],
            editedIndex: -1,
            editedItem: {
                id: '',
                title: '',
                status: 'pending',
                team: '',
                description: ''
            },
            defaultItem: {
                id: '',
                title: '',
                status: 'pending',
                team: '',
                description: ''
            },
            statuses: [
                { label: 'Completed', value: 'completed' },
                { label: 'In Progress', value: 'in_progress' },
                { label: 'Pending', value: 'pending' },
                { label: 'Cancelled', value: 'cancelled' },
            ],
            teams: []
        }),

        components: {
            ValidationProvider,
            ValidationObserver,
        },

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Phase' : 'Edit Phase'
            },
            computedStartDateFormatted () {
                return this.formatDate(this.editedItem.start_date)
            },
            computedEndDateFormatted () {
                return this.formatDate(this.editedItem.end_date)
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        created () {
            this.getPhaselist()
        },

        methods: {
            getPhaselist() {
                if(this.job) {
                    this.loading = true
                    axios.get('crm/job/phaselist/get?id=' + this.job)
                        .then(response => {
                            this.loading = false
                            this.phaselist = response.data.phaselist
                            this.teams = response.data.teams
                            this.$nextTick()
                        })
                }
            },

            editItem (item) {
                this.editedIndex = this.phaselist.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem (item) {
                this.editedIndex = this.phaselist.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            deleteItemConfirm () {
                this.loading = true
                axios.delete('crm/job/phaselist/delete?id=' + this.editedIndex)
                    .then(() => {
                      this.closeDelete()
                      this.getPhaselist()
                      this.$nextTick()
                    })
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            async save () {
                if (this.editedIndex > -1) {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      axios.post('crm/job/phaselist/update', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getPhaselist()
                          this.close()
                      }).catch(error => {
                          console.log(error)
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                } else {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      this.$set(this.editedItem, 'job', this.job)
                      axios.post('crm/job/phaselist/add', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getPhaselist()
                          this.close()
                      }).catch(error => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                }
            },

            getTeam(id) {
              let teams = this.teams.filter(team => {
                return team.id == id
              })

              if(teams.length) 
                return teams[0].title
            },


            saveField(id) {
              let item = this.phaselist.filter(pl => {
                return pl.id == id
              })

              if(item.length) {
                axios.post('crm/job/phaselist/update', item[0]).then(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    this.getPhaselist()
                }).catch(error => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    if(error.response.data.error) {
                        this.$store.commit('SET_SNACK', error.response.data.error)
                    } else {
                        this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                    }
                })     
              } 
            },
        },
    }
</script>